import { Component, Input } from '@angular/core';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';

@Component({
  selector: 'app-equity-element-not-found',
  templateUrl: './equity-element-not-found.component.html',
  styleUrls: ['./equity-element-not-found.component.scss'],
  standalone: false
})
export class EquityElementNotFoundComponent implements EquityPageComponentModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;
}
